import React from 'react';
import { Box, LinearProgress, Typography } from '@material-ui/core';
import styles from './styles';

const progressBar = (props) => {
    const classes = styles();

    return (
        <div className='mb-2'>
            <Typography className={classes.texto}>
                {props.progressInfo.fileName.substring(0, 40) +
                    (props.progressInfo.fileName.length > 40 ? '...' : '')}
            </Typography>
            <div className={classes.containerBarra}>
                <Box display='flex' alignItems='center'>
                    <Box width='100%' mr={1}>
                        <LinearProgress
                            className={classes.barra}
                            variant='determinate'
                            value={parseInt(props.progressInfo.percentage)}
                        />
                    </Box>
                    <Box minWidth={35}>
                        <Typography
                            className={classes.texto}
                            color='textSecondary'
                        >{`${Math.round(
                            props.progressInfo.percentage
                        )}%`}</Typography>
                    </Box>
                </Box>
            </div>
        </div>
    );
};

export default progressBar;
